import { useEffect } from "react"
import { ILanding, ILandingSection } from "../../../data/interfaces"
import { ILandingStore, useLandingStore } from "../../../data/store"
import { MENU_ITEM_ICON_DIVIDER, MENU_ITEM_WIDGET } from "src/libs/basic-view/ExtendMenu"

/* Protopia Ecosystem component */
export interface ISectionContainerProps {
   section: ILandingSection
   i: number
   children: JSX.Element
   className?: string
}
const SectionContainer = ({section, ...props}: ISectionContainerProps): JSX.Element => {
   const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding) 
   const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)

   useEffect(() => {

   }, [])
   
   const _id: string = section.id.toString()
   const type = section.data.map(d => d.type)  
   
   return <>
      <div 
         className={ `landing-section-container landing-gap ${ currentLanding.sectionClass || "" } ${props.className || ""}` } 
         id={ _id } 
         data-type={ type.join(",") }
         context-title={
            isEdit 
            ? 
            [
               [
                  `Section's settings${MENU_ITEM_ICON_DIVIDER}cog`,
                  `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}compositionWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,
                  `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}carouselWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,               
                  `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}tabsWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,   
                  `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}columnWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,                
                  `Title${MENU_ITEM_ICON_DIVIDER}header${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.title`,
                  `Description${MENU_ITEM_ICON_DIVIDER}font${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.description`,
                  `Background${MENU_ITEM_ICON_DIVIDER}selection-box${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.background`,
                  `Divider${MENU_ITEM_ICON_DIVIDER}vertical-distribution${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.delimiter`
               ].join("||"),
               `Add Meat to end${MENU_ITEM_ICON_DIVIDER}plus${MENU_ITEM_ICON_DIVIDER}addMeat${MENU_ITEM_ICON_DIVIDER}${_id}`,
               `Delete Section${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteSection${MENU_ITEM_ICON_DIVIDER}${_id}`,
            ].join("|||")
            : 
            undefined
         }
      >
         {props.children}
      </div> 
   </>
}
export default SectionContainer